import {
  ANALYTIC_EVENT_CATEGORY,
  ANALYTIC_EVENT_CONTEXT,
  ANALYTIC_EVENT_EVENTS,
  ANALYTIC_EVENT_LABELS,
  ANALYTIC_EVENT_TYPES,
  CONVERSIONS,
  INTERACTIONS,
} from '../constants';
import { SelectProfileRequestParams } from '@lentau/profile/shared/interfaces/profile-common-info';
import { BaseEventGTM } from '../events-interfaces/base-event';

export const getOpenAuthorizationPageGTM = (): BaseEventGTM => {
  return {
    event: ANALYTIC_EVENT_TYPES.OWOX,
    eventCategory: ANALYTIC_EVENT_CATEGORY.logIn,
    eventAction: ANALYTIC_EVENT_EVENTS.view,
    eventLabel: ANALYTIC_EVENT_LABELS.loginORregistration,
    eventContext: ANALYTIC_EVENT_EVENTS.view,
  };
};

export const getInputOtpSuccessEventGTM = (): BaseEventGTM => {
  return {
    event: ANALYTIC_EVENT_TYPES.OWOX,
    eventCategory: CONVERSIONS,
    eventAction: ANALYTIC_EVENT_EVENTS.click,
    eventLabel: ANALYTIC_EVENT_LABELS.sendSuccess,
    eventContext: ANALYTIC_EVENT_CONTEXT.sms,
  };
};

export const getProfileSelectEventGTM = (
  selectedProfile: SelectProfileRequestParams,
  isSignInEvent?: boolean
): BaseEventGTM => {
  let eventLabel: string = selectedProfile?.legalEntityId
    ? ANALYTIC_EVENT_LABELS.urLico
    : ANALYTIC_EVENT_LABELS.fizLico;

  if (isSignInEvent) {
    eventLabel = `${eventLabel} / ${ANALYTIC_EVENT_LABELS.signInSuccess}`;
  }

  return {
    event: ANALYTIC_EVENT_TYPES.OWOX,
    eventCategory: INTERACTIONS,
    eventAction: ANALYTIC_EVENT_EVENTS.click,
    eventLabel,
    eventContext: ANALYTIC_EVENT_CONTEXT.sms,
  };
};
